export default "__VITE_ASSET__2a2e9ca7__"